import React, { useState, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { checkIsPhoneNumberValid } from '../../../services/helper';
import { BsCheckSquare, BsXSquare } from 'react-icons/bs'
import { Loader } from 'rsuite';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { RiFileCopyLine } from 'react-icons/ri'

const StickyHeader = ({ vendorDetails, searchList, setSearchList, setOnClear, copyBtn = false, contactsData = [] }) => {
    const headerColumns = [
        { name: 'suppliername', label: 'Name' },
        { name: 'address1', label: 'Address' },
        { name: 'phone', label: 'Phone' },
        { name: 'city', label: 'City' },
        { name: 'email', label: 'Email' },
        [
            { name: 'state', label: 'State' },
            { name: 'zip', label: 'Zip' }
        ]
    ]

    const dispatch = useDispatch()
    const [vendorInformation, setVendorInformation] = useState({})
    const [isValidatingPhone, setIsValidatingPhone] = useState(false)
    const [isPhoneValid, setIsPhoneValid] = useState('')
    
    useEffect(async () => {
        let tmpVendorDetails = { ...vendorDetails }
        const tmpPhoneValue = (vendorDetails?.['phone'] && /^\d+$/.test(vendorDetails?.['phone']) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(vendorDetails?.['phone'])) ? contactsData?.find(data => data?.id === parseInt(vendorDetails?.phone))?.phone : (vendorDetails?.['phone'] || '')
        const tmpEmailValue = (vendorDetails?.['email'] && /^\d+$/.test(vendorDetails?.['email'])) ? contactsData?.find(data => data?.id === parseInt(vendorDetails?.email))?.email : (vendorDetails?.['email'] || '')
        const usArray = ['united states', 'usa', 'us']
        var phoneValue = !tmpPhoneValue ? '' : tmpPhoneValue?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? tmpPhoneValue : vendorDetails?.['country'] && usArray.includes(vendorDetails?.['country'].toLowerCase()) && tmpPhoneValue.startsWith('1') ? tmpPhoneValue : ((vendorDetails?.['country'] && !usArray.includes(vendorDetails?.['country'].toLowerCase()))) ? tmpPhoneValue : tmpPhoneValue.startsWith('1') ? tmpPhoneValue : '1 ' + tmpPhoneValue

        tmpVendorDetails['phone'] = phoneValue
        tmpVendorDetails['email'] = tmpEmailValue
        setVendorInformation(tmpVendorDetails)
    }, [])

    useEffect(async () => {
        if (Object.values(vendorInformation).length > 0 && !isValidatingPhone) {
            var phoneNumber = !vendorInformation?.['phone'] ? '' : vendorInformation?.['phone']?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? vendorInformation?.['phone'] : '1 ' + vendorInformation?.['phone']
            var phoneValueWithCode = phoneNumber
            if (phoneNumber !== '') {
                setIsValidatingPhone(true)
                phoneNumber = phoneNumber.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
                var phoneValidationResult = await checkIsPhoneNumberValid(phoneNumber, phoneValueWithCode, dispatch)
                setIsPhoneValid(phoneValidationResult?.isPhoneValid)
                setIsValidatingPhone(phoneValidationResult?.isValidatingPhone)
            } else {
                setIsPhoneValid(true)
            }
            setVendorInformation({ ...vendorInformation, 'phone': phoneValidationResult?.phoneNumber })
        }
    }, [Object.values(vendorInformation).length])

    const onCopyHandler = (value, col) => {
        if (value === "") {
            return;
        }
        setSearchList(prevState => {
            return {
                ...prevState,
                [col.name]: value
            }
        })
    }

    return (
        <div className="header position-sticky top-0 pb-4 sticky-header bg-white">
            <h5 className='text-black fw-bold'> Imported Supplier </h5>
            <div className='row gap-0 border border-2 rounded ms-0 me-0 p-3'>
                {headerColumns.map((column, index) => {
                    return (
                        <div className={`col-6 d-flex align-items-center gap-3 ${index < (headerColumns.length - 2) ? 'mb-4' : ''}`}>
                            {Array.isArray(column) ?
                                column.map((col, index) => {
                                    return (
                                        <div className='gap-3 d-flex align-items-center'>
                                            <h4 className={`label mb-0 flex-grow-1 ${index === 1 ? 'w-50' : 'w-75'}`}>{col.label}:</h4>
                                            <div style={{ backgroundColor: "#EFEFEF4D" }} className='border rounded d-flex'>
                                                <input
                                                    className='search-input border-0 w-75 '
                                                    value={vendorInformation?.[col.name] || ''}
                                                    title={vendorInformation?.[col.name] || ''}
                                                    disabled={true}
                                                />
                                                {copyBtn && <div className='w-25 d-flex justify-content-start'>
                                                    {
                                                        vendorInformation?.[col.name] === null || vendorInformation?.[col.name] === undefined ? null : (
                                                            <CopyToClipboard text={vendorInformation?.[column.name]}  >
                                                                <button
                                                                    style={{ backgroundColor: "#EFEFEF4D" }}

                                                                    onClick={() => {
                                                                        setOnClear(false);
                                                                        onCopyHandler(vendorInformation?.[col.name], col);
                                                                    }}
                                                                >
                                                                    <RiFileCopyLine size={26} color="rgb(87 171 234)" />
                                                                </button>
                                                            </CopyToClipboard>
                                                        )
                                                    }

                                                </div>}
                                            </div>
                                        </div>
                                    )
                                })
                                :
                                <>
                                    <h4 className="label mb-0 w-25 flex-grow-1">{column.label}:</h4>
                                    {column.name === 'phone' ?
                                        <div className="w-100 flex align-center flex-grow-1 gap-2">
                                            <div className='d-flex border border-1  phone-input-ext-container w-100 flex-column flex-lg-row'>
                                                <ReactPhoneInput
                                                    className='phone-input-parent'
                                                    country={'us'}
                                                    value={vendorInformation?.[column.name] || ''}
                                                    title={vendorInformation?.[column.name] || ''}
                                                    countryCodeEditable={false}
                                                    preferredCountries={['us']}
                                                    disabled={true}
                                                    buttonClass='border-0    border-dark'
                                                    inputProps={{
                                                        className: 'form-control border-0 rounded-0'

                                                    }}
                                                />

                                                {copyBtn && <div style={{ backgroundColor: "#E9ECEF" }} className='d-flex align-items-center'>
                                                    {
                                                        vendorInformation?.[column.name] === null || vendorInformation?.[column.name] === undefined ? null : (
                                                            <CopyToClipboard text={vendorInformation?.[column.name] || '344'} >
                                                                <button
                                                                    style={{ backgroundColor: "#E9ECEF" }}
                                                                    onClick={() => {
                                                                        setOnClear(false);
                                                                        onCopyHandler(vendorInformation?.[column.name], column)
                                                                    }}
                                                                >
                                                                    <RiFileCopyLine size={26} color="rgb(87 171 234)" />
                                                                </button>
                                                            </CopyToClipboard>
                                                        )
                                                    }

                                                </div>}
                                            </div>
                                            {isValidatingPhone && (<Loader />)}
                                            {vendorInformation[column.name] && !isValidatingPhone && isPhoneValid !== '' &&
                                                (isPhoneValid ?
                                                    <BsCheckSquare color="#067911" size={26} />
                                                    :
                                                    <BsXSquare color="#f75a52" size={26} />
                                                )
                                            }
                                        </div>
                                        :
                                        <div className='d-flex border border-1 w-100 h-100 border rounded'>
                                            <div className=' w-75 h-100'>
                                                <input
                                                    className='search-input flex-grow-1 w-100 border-0 '
                                                    value={vendorInformation?.[column.name] || ''}
                                                    title={vendorInformation?.[column.name] || ''}
                                                    disabled={true}
                                                />
                                            </div>
                                            {copyBtn && <div style={{ backgroundColor: "#EFEFEF4D" }} className='d-flex justify-content-end  align-items-center  w-25 h-100'>
                                                {
                                                    vendorInformation?.[column.name] === null || vendorInformation?.[column.name] === undefined ? null : (
                                                        <CopyToClipboard text={vendorInformation?.[column.name]} >
                                                            <button
                                                                style={{ backgroundColor: "#EFEFEF4D" }}
                                                                onClick={() => {
                                                                    setOnClear(false);
                                                                    onCopyHandler(vendorInformation?.[column.name], column)
                                                                }}
                                                            >
                                                                <RiFileCopyLine size={26} color="rgb(87 171 234)" />
                                                            </button>
                                                        </CopyToClipboard>
                                                    )
                                                }
                                            </div>}
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default StickyHeader